/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CaptchaValidationDto
 */
export interface CaptchaValidationDto {
    /**
     * captcha token
     * @type {string}
     * @memberof CaptchaValidationDto
     */
    token: string;
    /**
     * 
     * @type {boolean}
     * @memberof CaptchaValidationDto
     */
    useIpValidation?: boolean;
}

/**
 * Check if a given object implements the CaptchaValidationDto interface.
 */
export function instanceOfCaptchaValidationDto(value: object): boolean {
    if (!('token' in value)) return false;
    return true;
}

export function CaptchaValidationDtoFromJSON(json: any): CaptchaValidationDto {
    return CaptchaValidationDtoFromJSONTyped(json, false);
}

export function CaptchaValidationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaptchaValidationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'token': json['token'],
        'useIpValidation': json['useIpValidation'] == null ? undefined : json['useIpValidation'],
    };
}

export function CaptchaValidationDtoToJSON(value?: CaptchaValidationDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'token': value['token'],
        'useIpValidation': value['useIpValidation'],
    };
}

